import { TrialCommunicationConfiguration, PersonalCodeConfiguration, TrialCreationBehavior } from '../..';
import { UsageLimit } from './usage-limit';

export enum TerminationBehavior {
  AutoConvert = 'AutoConvert',
  Terminate = 'Terminate',
}

export class TrialConfiguration {
  creationBehavior: TrialCreationBehavior;
  terminationBehavior: TerminationBehavior;

  usageLimit?: UsageLimit;

  personalCodeConfiguration?: PersonalCodeConfiguration;
  communicationConfiguration?: TrialCommunicationConfiguration;

  constructor(json: any) {
    this.creationBehavior = json.creationBehavior;
    this.terminationBehavior = json.terminationBehavior;

    this.usageLimit = json.usageLimit ? UsageLimit.getFactory().make(json.usageLimit) : undefined;

    this.personalCodeConfiguration = json.personalCodeConfiguration;
    this.communicationConfiguration = json.communicationConfiguration;
  }
}
